import { getStatement } from 'Api/statementApi'
import { parseStatement } from 'Parsers/statementParser'

const state = {
  isRequesting: false,

  list: [],
}

const mutations = {
  request_statement_start(state) {
    state.isRequesting = true
  },

  request_statement_success(state) {
    state.isRequesting = false
  },

  request_statement_failure(state) {
    state.isRequesting = false
  },

  set_statement_list(state, list) {
    state.list = list
  }
}

const actions = {
  async getStatement({ commit }, days) {
    commit('request_statement_start')

    try {
      const { data } = await getStatement(days)
      const list = data.map(parseStatement).reverse()

      commit('set_statement_list', list)
      commit('request_statement_success')

      return data
    } catch (err) {
      commit('request_statement_failure')

      throw err
    }
  }
}

export default {
  namespaced: true,

  state,
  actions,
  mutations
}